import {helpers} from '@vuelidate/validators';

export const passwordValid = helpers.withMessage(
    'La contraseña debe tener al menos un número, al menos una minúscula y al menos una mayúscula.',
    helpers.regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d$@$!%*?&.#/()=]{8,}/)
);
